export default __webpack_public_path__ + "static/media/logo.27290120.svg";